import Layout from "../Layout/Layout.tsx";
import Serenity from "../../componenets/Card/Cards/Serenity.tsx";
import Commodore from "../../componenets/Card/Cards/Commodore.tsx";
import { PiDetective } from "react-icons/pi";
import { MdCarRepair } from "react-icons/md";
import { GiSurferVan } from "react-icons/gi";
import { JsonLDData } from "react-safe-json-ld";

const Fleet = () => {
  const structuredData: JsonLDData = {
    "@context": "https://schema.org",
    "@graph": [

      {
        "@type": "AutoRental",
        "@id": "https://earthboundmartian.com/#business",
        "name": "Earthbound Martian Landship Rentals",
        "description": "Rent rugged camper vans for kayaking, fishing, hiking, and camping adventures within 350 miles of DFW.",
        "url": "https://earthboundmartian.com",
        "address": {
          "@type": "PostalAddress",
          "addressLocality": "Richardson",
          "addressRegion": "TX",
          "addressCountry": "US"
        },
        "areaServed": {
          "@type": "GeoCircle",
          "geoMidpoint":
          {
            "@type": "GeoCoordinates",
            "latitude": 32.9686,
            "longitude": -96.9942
          },
          "geoRadius": "350 mi"
        }
      },
      {
        "@type": "ItemList",
        "itemListElement": [
          { "@type": "ListItem", "position": 1, "item": { "@type": "CamperVan", "name": "Landship Commodore Camper Van" } },
          { "@type": "ListItem", "position": 2, "item": { "@type": "Bus Conversion", "name": "Landship Serenity Camper Van" } }
        ]
      }
    ]
  };

  return (
    <Layout structuredData={structuredData}>
      <section className="max-w-7xl mx-auto px-6 py-20">
        <h1 className="text-5xl font-bold text-alt-blk mb-4">Our Fleet</h1>
        <p className="text-xl text-zinc-600 mb-16">
          Meet the fleet! Our ever growing fleet of Landships are hand crafted
          by our team to provided the best in comfort, safety, and reliability
          on the road.
        </p>

        <div className="space-y-20">
          <Commodore />
          <Serenity />
        </div>
      </section>

      {/* Our Approach */}
      <section className="bg-zinc-100 py-20">
        <div className="max-w-7xl mx-auto px-6">
          {/* <section className="max-w-7xl mx-auto px-6 py-20 bg-white"> */}
          <h2 className="text-4xl font-bold text-alt-blk mb-12 text-center">
            How We Build Our Landships
          </h2>

          <div className="max-w-4xl mx-auto space-y-16">
            <div className="flex gap-8">
              <div className="flex-shrink-0 w-12 h-12 rounded-2xl bg-mars text-white flex items-center justify-center text-3xl font-bold">
                <PiDetective />
              </div>
              <div>
                <h3 className="font-semibold text-2xl mb-3">
                  Find Road Warriors
                </h3>
                <p className="text-zinc-600 text-lg">
                  We seek out battle-tested vehicles that have already served
                  their previous owners well and proven they can handle the
                  miles.
                </p>
              </div>
            </div>

            <div className="flex gap-8">
              <div className="flex-shrink-0 w-12 h-12 rounded-2xl bg-mars text-white flex items-center justify-center text-3xl font-bold">
                <MdCarRepair />
              </div>
              <div>
                <h3 className="font-semibold text-2xl mb-3">
                  Strip & Strengthen
                </h3>
                <p className="text-zinc-600 text-lg">
                  We completely gut the interior and fix any fundamental issues,
                  giving the rig a solid, reliable foundation.
                </p>
              </div>
            </div>

            <div className="flex gap-8">
              <div className="flex-shrink-0 w-12 h-12 rounded-2xl bg-mars text-white flex items-center justify-center text-3xl font-bold">
                <GiSurferVan />
              </div>
              <div>
                <h3 className="font-semibold text-2xl mb-3">Rebuild Better</h3>
                <p className="text-zinc-600 text-lg">
                  Using state-of-the-art techniques and equipment, we build
                  modern, comfortable living spaces that are truly ready to be
                  lived in.
                </p>
              </div>
            </div>
          </div>
        </div>
        {/* </section> */}
      </section>
    </Layout>
  );
};

export default Fleet;
